export default {
  BANNER_IMG_PATH: 'banners/green-vegetables-banner',
  CLOUDINARY_BASE_URL: 'https://res.cloudinary.com/keplr/image/upload',
  IOD_BASE_URL_PROD: 'https://iod.keplrstatic.com/api',
  IOD_BASE_URL_STAGING: 'https://iod.staging.keplrstatic.com/api',
  IOD_BASE_URL_DEV: 'https://iod.dev.keplrstatic.com/api',
  IOD_IMG_ROOTPATH: '/mon_marche/',
};
